<template>
    <div class="ur-carousel-item" :style="carousel.iStyle"><!--
        $ver: v0.1.0
        컨텐츠 영역입니다. 주로 이미지로 활용됩니다.
        #The content area. It is mainly used as an image.
    --><slot></slot>
    </div>
</template>

<script>
// ur-carousel-item은 ur-carousel의 한 페이지를 담당하는 컨텐츠 영역의 역할을 합니다.
// #The ur-carousel-item acts as a content area responsible for one page of ur-carousel.

export default {
    name: 'urCarouselItem',
    inject: ['carousel'],
    props:{
        // $ver: v0.1.0
        // 썸네일 문자열 입니다. 현재 사용되지 않습니다.
        // #Thumbnail string. Currently not used.
        // $deprecated
        thumb:{type:String}
    }
};


</script>
